import React from "react";
import { QueryRenderer, graphql } from "react-relay";
import { connect } from "react-redux";
import ReactDom from "react-dom";
import PropTypes from "prop-types";

import environment from "../../relay/environment";
import Trip from "./Trip";
import TripListFilters from "./TripListFilters";
import styles from "./styles.scss";

class RenderedTrips extends React.Component {
  static propTypes = {
    trips: PropTypes.arrayOf(PropTypes.object).isRequired,
    activeTrip: PropTypes.string,
  };

  static defaultProps = {
    activeTrip: "",
  };

  componentDidMount() {
    this.scrollToTrip();
  }

  componentDidUpdate() {
    this.scrollToTrip();
  }

  scrollToTrip = () => {
    const node = ReactDom.findDOMNode(this.refs.activeTrip); // eslint-disable-line
    if (node) {
      node.scrollIntoView({ behavior: "instant", block: "start" });
    }
  };

  render() {
    const { trips, activeTrip } = this.props;

    return (
      <div className={styles.listItems}>
        {trips.map((trip) => {
          const { id: tripId } = trip;
          const active = tripId === activeTrip;
          const ref = active ? "activeTrip" : null;

          return <Trip key={tripId} trip={trip} active={active} ref={ref} />;
        })}
      </div>
    );
  }
}

@connect((state) => ({
  windowHeight: state.Responsive.get("windowHeight"),
  filter: state.Trips.get("filter"),
  selectedUser: state.Trips.get("selectedUser"),
}))
class Renderer extends React.Component {
  // eslint-disable-line
  static propTypes = {
    filter: PropTypes.string.isRequired,
    activeTrip: PropTypes.string,
    selectedUser: PropTypes.string.isRequired,
    loadingEl: PropTypes.element.isRequired,
  };

  static defaultProps = {
    activeTrip: "",
  };

  tripNeeds = (trip, need) => {
    const {
      book,
      dropbox,
      invoice,
      actionableInvoice,
      draftVip,
      needsTraining,
      needsVetting,
      insideCircle,
      cancel,
      prospect,
      specificDates,
      highPriority,
      welcomeHome,
    } = trip;

    if (need === null) {
      return true;
    } else if (need === "book") {
      return book;
    } else if (need === "filing") {
      return dropbox;
    } else if (need === "invoice") {
      return invoice;
    } else if (need === "actionableInvoice") {
      return actionableInvoice;
    } else if (need === "vip") {
      return draftVip;
    } else if (need === "training") {
      return needsTraining;
    } else if (need === "vetting") {
      return needsVetting;
    } else if (need === "insideCircle") {
      return insideCircle;
    } else if (need === "cancellation") {
      return cancel;
    } else if (need === "prospect") {
      return prospect && !specificDates;
    } else if (need === "highPriority") {
      return highPriority;
    } else if (need === "welcomeHome") {
      return welcomeHome;
    }

    return true;
  };

  render() {
    const {
      filter: filterNeed,
      activeTrip,
      selectedUser,
      loadingEl,
    } = this.props;

    return (
      <QueryRenderer
        environment={environment}
        query={graphql`
          query TripListRenderer_TripList_Query {
            allTrips {
              edges {
                node {
                  id
                  tripName
                  primaryTravelerName
                  destination
                  dateString
                  specificDates
                  ownerId
                  ownerName
                  numSegments
                  dropbox
                  invoice
                  actionableInvoice
                  draftVip
                  book
                  cancel
                  welcomeHome
                  numTravelers
                  inbox
                  tier
                  fired
                  lowPriority
                  needsTraining
                  needsVetting
                  insideCircle
                  prospect
                  highPriority
                }
              }
            }
          }
        `}
        render={({ error, props }) => {
          if (error) {
            return <div>{error.message}</div>;
          } else if (props) {
            const {
              allTrips: { edges: trips },
            } = props;

            const users = {};
            const filteredTrips = trips
              .filter(({ node: trip }) => {
                const { ownerId, ownerName } = trip;
                users[ownerId] = { id: ownerId, name: ownerName };

                const match =
                  (selectedUser === "all" || ownerId === selectedUser) &&
                  (filterNeed === "all" || this.tripNeeds(trip, filterNeed));

                return match;
              })
              .map(({ node: trip }) => trip);

            return (
              <div>
                <TripListFilters
                  filter={filterNeed}
                  users={users}
                  numFiltered={filteredTrips.length}
                  numTrips={trips.length}
                />
                <RenderedTrips trips={filteredTrips} activeTrip={activeTrip} />
              </div>
            );
          }

          return loadingEl;
        }}
      />
    );
  }
}

export default Renderer;



// WEBPACK FOOTER //
// /src/components/Trips/TripListRenderer.js